import React, { useState, useEffect } from "react";
import styles from "./Dashboard.module.css";

import { getAllFolders, addFolder, getFormByFolder, deleteFormById, deleteFolderById } from "../../api/form";

import folderimg from "../../images/folderimg.svg";
import delete2 from "../../images/delete.svg";
import typebotimg from "../../images/typebotimg.svg";
import Line4 from "../../images/Line4.svg";
import arrow from "../../images/arrow.svg";
import arrowup from "../../images/arrowup.svg";
import arrowdown from "../../images/arrowdown.svg";
import { useNavigate } from "react-router-dom";

export default function Dashboard() {

  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [settingsPage, setSettingsPage] = useState(false);
  const [formid,setFormid] = useState(null);
  const [folderid,setFolderid] = useState(null);

  const [selectedFolder, setSelectedFolder] = useState("default_folder");
  const [folders, setFolders] = useState([]);
  const [typebots, setTypebots] = useState([]);
  const [isFolderaddHidden, setIsFolderaddHidden] = useState(true);
  const [isgrp2Hidden, setIsgrp2Hidden] = useState(false);
  const [isfolderdelHidden, setIsfolderdelHidden] = useState(true);
  const [isfiledelHidden, setIsfiledelHidden] = useState(true);
  const [isErrorHidden, setIsErrorHidden] = useState(true);
  const [formValues, setFormValues] = useState({ name: "" });
  const [errors, setErrors] = useState({ name: null });

  const [token] = useState(!!localStorage.getItem("token"));

  const navigate = useNavigate();

  const logout = () => {
    localStorage.clear();
    navigate("/login");
};


  const handleChange = (e) => {
    setIsErrorHidden(true);
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleCreateFolder = () => {
    setIsFolderaddHidden(!isFolderaddHidden);
    setIsgrp2Hidden(!isgrp2Hidden);
  };

  const closecreateFolder = () => {
    setIsFolderaddHidden(!isFolderaddHidden);
    setIsgrp2Hidden(!isgrp2Hidden);
  };

 
  const openDelForm = async (id) => {
       setFormid(id);
      
  
      
    setIsfiledelHidden(!isfiledelHidden);
    setIsgrp2Hidden(!isgrp2Hidden);
  };
  
  const handleDelForm = () => {
    
    try {
       deleteFormById(formid);
   } catch (error) {
     console.error(error);
   }
   
   setIsfiledelHidden(!isfiledelHidden);
   setIsgrp2Hidden(!isgrp2Hidden);
   
      
    
  };
   const closeDelForm = () => {
   setIsfiledelHidden(!isfiledelHidden);
   setIsgrp2Hidden(!isgrp2Hidden);
   
      
    
  };

  const openDelFolder = async (id) => {
       setFolderid(id);
      
  
      
    setIsfolderdelHidden(!isfolderdelHidden);
    setIsgrp2Hidden(!isgrp2Hidden);
  };
  
  const closeDelFolder = () => {
    setIsfolderdelHidden(!isfolderdelHidden);
    setIsgrp2Hidden(!isgrp2Hidden);
  };
  const handleDelFolder = () => {

    try {
      deleteFolderById(folderid);
  } catch (error) {
    console.error(error);
  }
  

    if (isFolderaddHidden === false || isfiledelHidden === false) {
      setIsFolderaddHidden(true);
      setIsfiledelHidden(true);
      
    }

    setIsfolderdelHidden(!isfolderdelHidden);
    setIsgrp2Hidden(!isgrp2Hidden);
   
    
  };
  

  const handleCreateTypebot = () => {
    setTypebots([...typebots, { formname: `New Form ${typebots.length + 1}`, _id:'newform' }]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isErrors = false;

    if (formValues.name.trim().length === 0) {
      setIsErrorHidden(false);
      setErrors((prev) => ({ ...prev, name: "Invalid name" }));
      isErrors = true;
    } else if (checkDuplicateFolder(formValues.name)) {
      setIsErrorHidden(false);
      setErrors((prev) => ({ ...prev, name: "Folder name already exists" }));
      isErrors = true;
    } else {
      setIsErrorHidden(true);
      setErrors((prev) => ({ ...prev, name: null }));
    }

    if (!isErrors) {
      try {
        const result = await addFolder(formValues);
        if (result) {
          setFolders([...folders, { name: formValues.name }]);
          navigate("/dashboard");
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  const checkDuplicateFolder = (folderName) => {
    return folders.some((folder) => folder.name === folderName);
  };

  const handleFolderClick = async (name) => {
    setSelectedFolder(name);
    try {
      const formdata = await getFormByFolder(name);
      setTypebots(formdata);
    } catch (error) {
      console.error(error);
    }

    
  };

  const handleCreateFormClick = (formname) => {
    if (selectedFolder) {
      navigate(`/formbuilder/${selectedFolder}/${formname}`);
    } else {
      navigate(`/formbuilder/default_folder/${formname}`);
    }
  };

  useEffect(() => {
    if (!token) {
      navigate('/login');
    }
    const fetchFolders = async () => {
      try {
        const foldersData = await getAllFolders();
        setFolders(foldersData);
      } catch (error) {
        console.error('Error fetching folders:', error);
      }
    };

    const fetchForms = async () => {
      try {
        const formdata = await getFormByFolder(selectedFolder);
        setTypebots(formdata);
      } catch (error) {
        console.error('Error fetching forms:', error);
      }
    };

    fetchFolders();
    fetchForms();
  }, [selectedFolder,isfiledelHidden,isfolderdelHidden,token, navigate]);

  const D = JSON.parse(localStorage.getItem("name")) || "";
  

  const toggleDropdown = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  const settingsPageclick = () => {
   setSettingsPage (!settingsPage);
  };
  const gotoDashboard = () => {
   setSettingsPage (!settingsPage);
  };

  return (
    <>
            {token ? (
              <>
            {!settingsPage ? (
    <div className={styles.dashboard}>
      <div className={styles.header}>
      {!isDropdownOpen && (<><button onClick={toggleDropdown} type="button">{D}'s workspace</button><img onClick={toggleDropdown} className={styles.arrowdown} src={arrowdown} alt='' /></>
      )}
        {isDropdownOpen && (
        <div className={styles.dropdownMenu}>
          <button className={styles.dropdownItem0} onClick={toggleDropdown} type="button">{D}'s workspace </button><img onClick={toggleDropdown} className={styles.arrowup} src={arrowup} alt='' />
          <button className={styles.dropdownItem1} onClick={settingsPageclick}>Settings</button>
          <button className={styles.dropdownItem2} onClick={logout}>Log Out</button>
        </div>
      )}
      </div>

      <div className={styles.create}>
        <div onClick={handleCreateFolder}>
          <button className={styles.folder}>Create a folder</button>
          <img src={folderimg} className={styles.folderimg} alt='' />
        </div>
        <div onClick={handleCreateTypebot}>
          <button className={styles.typebot}>Create a typebot</button>
          <img src={typebotimg} className={styles.typebotimg} alt='' />
        </div>
        <form onSubmit={handleSubmit}>
          <div className={styles.folderadd} hidden={isFolderaddHidden}>
            <img src={Line4} alt='' />
            <p>Create New Folder</p>
            <input placeholder='Enter folder name' onChange={handleChange} name="name" />

            <button className={styles.done} type="submit">Done</button>
            <button className={styles.cancel2} type="button" onClick={closecreateFolder}>Cancel</button>
            <h2 hidden={isErrorHidden} className={styles.errormsg11}>{errors.name}</h2>

          
            <p hidden={isErrorHidden}>{errors.name}</p>

          </div>
        </form>

        <div className={styles.folderdel} hidden={isfolderdelHidden}>
          <img src={Line4} alt='' />
          <p>Are you sure you want to delete this folder?</p>
          <button className={styles.donedel} onClick={handleDelFolder}>Confirm</button>
          <button className={styles.canceldel} onClick={closeDelFolder}>Cancel</button>
        </div>

        <div className={styles.filedel} hidden={isfiledelHidden}>
          <img src={Line4} alt='' />
          <p>Are you sure you want to delete this form?</p>
          <button className={styles.donedel1} onClick={handleDelForm}>Confirm</button>
          <button className={styles.canceldel2 } onClick={closeDelForm}>Cancel</button>
        </div>
      </div>

        <div className={styles.grp1}>
          {folders.map((folder) => (
            <button
              key={folder._id}
              className={`${styles.folders} ${selectedFolder === folder.name ? styles.highlightedfolder : ""}`}
              onClick={() => handleFolderClick(folder.name)}
            >{folder.name}
              <img src={delete2} className={styles.delete2} onClick={() => openDelFolder(folder._id)} alt='' />
            </button>
          ))}
        </div>

      {!isgrp2Hidden && (
        <div className={styles.grp2}>
          {typebots.map((typebot, index) => (
            <div key={index} className={styles.formContainer} >
              <button className={styles.forms} onClick={() => handleCreateFormClick(typebot._id)}>{typebot.formname}</button>
              <img src={delete2} className={styles.delete20} onClick={() => openDelForm(typebot._id)} alt='' />
            </div>
          ))}
        </div>
      )}
    </div>
   ) : (
      <>
       <div className={styles.settings}>
      <img className={styles.arrow} src={arrow} onClick={gotoDashboard} alt='arrow' />
     <form onSubmit={handleSubmit}>
        <div>
          <label className={`${styles.label1} ${errors.name ? styles.errorLabel : ''}`} htmlFor="name">Username</label><br />
          <input
            type="text"
            className={`${styles.input1} ${errors.name ? styles.errorInput : ''}`}
            placeholder="Name"
            value={formValues.name}
            onChange={handleChange}
            name="name"
          />
          {errors.name && <div className={styles.ename}>{errors.name}</div>}
        </div>
        <div>
          <label className={`${styles.label2} ${errors.email ? styles.errorLabel : ''}`} htmlFor="name">Email</label><br />
          <input
            type="email"
            className={`${styles.input2} ${errors.email ? styles.errorInput : ''}`}
            placeholder="Email"
            value={formValues.email}
            onChange={handleChange}
            name="email"
          />
          {errors.email && <div className={styles.eemail}>{errors.email}</div>}
        </div>
        <div>
          <label className={`${styles.label3} ${errors.password ? styles.errorLabel : ''}`} htmlFor="password">Password</label><br />
          <input
            type="text"
            className={`${styles.input3} ${errors.password ? styles.errorInput : ''}`}
            placeholder="Password"
            value={formValues.password}
            onChange={handleChange}
            name="password"
          />
          {errors.password && <div className={styles.epassword}>{errors.password}</div>}
        </div>
        <div>
          <label className={`${styles.label4} ${errors.checkpass ? styles.errorLabel : ''}`} htmlFor="checkpass">Confirm Password</label><br />
          <input
            type="text"
            className={`${styles.input4} ${errors.checkpass ? styles.errorInput : ''}`}
            placeholder="Confirm Password"
            value={formValues.checkpass}
            onChange={handleChange}
            name="checkpass"
          />
          {errors.checkpass && <div className={styles.echeckpass}>{errors.checkpass}</div>}
        </div>
        <button className={styles.register} type="submit">Update</button>
      </form>
      </div>
      </>
  )}
  </>
   ) : (
      <>
      </>
  )}
  
</>
  );
}